import React, { useEffect, useRef, useState } from 'react'
import { GGButton } from '../../../shared/new_components/GGButton'
import StatsComponent from '../shared/stats_component'
import EventsTable from './events_table'
import { useDispatch, useSelector } from 'react-redux'
import { getLeagues, publishLeague, toggleRegistration } from '../../actions/dashboard/events_index'
import PropTypes from 'prop-types'
import { callAPI } from '../../../shared/helpers'
import { GGInput } from '../../../shared/new_components/GGInput'

const SORT_FIELD_TO_ORDER_BY = {
  startDate: 'start_date',
  name: 'name',
}

const ELEMENTS_PER_PAGE = 10

const SEARCH_DEBOUNCE_MS = 300

const EventsComponent = () => {
  const leagues = useSelector(state => state.events.events)
  const numberOfGolfers = useSelector(state => state.events.totalGolfers)
  const entryFeeSum = useSelector(state => state.events.totalAmount)
  const numberOfLeagues = useSelector(state => state.events.numberOfLeagues)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchInput, setSearchInput] = useState('')
  const sortRef = useRef({ orderBy: 'start_date', orderType: 'descending' })
  const isInitialLoad = useRef(true)
  const dispatch = useDispatch()
  const createEventPath = useSelector(state => state.misc.getLeaguesPath)
  const customerId = useSelector(state => state.misc.customerId)

  const handleCreateEvent = () => {
    callAPI(createEventPath, 'POST', {customer_id: customerId})
      .then((response) => {
        window.location.pathname = `/leagues/${response['league_id']}/setup_golfhub_data`
      })
  }

  const handleChangePage = () => {
    if (currentPage + 1 <= Math.ceil(numberOfLeagues / ELEMENTS_PER_PAGE)) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handleSort = (field, ascending) => {
    sortRef.current = {
      orderBy: SORT_FIELD_TO_ORDER_BY[field],
      orderType: ascending ? 'ascending' : 'descending',
    }
    setCurrentPage(1)
    dispatch(getLeagues(1, searchInput, sortRef.current.orderBy, sortRef.current.orderType, true))
  }

  const handlePublish = (id, publishStatus) => {
    dispatch(publishLeague(id, !publishStatus))
  }

  const handleRegistration = (id, registrationStatus) => {
    dispatch(toggleRegistration(id, !registrationStatus))
  }

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false
      dispatch(getLeagues(1, searchInput, sortRef.current.orderBy, sortRef.current.orderType, true))
      return undefined
    }
    const debounceTimer = setTimeout(() => {
      setCurrentPage(1)
      dispatch(getLeagues(1, searchInput, sortRef.current.orderBy, sortRef.current.orderType, true))
    }, SEARCH_DEBOUNCE_MS)
    return () => clearTimeout(debounceTimer)
  }, [searchInput])

  useEffect(() => {
    if (currentPage === 1) { return }
    dispatch(getLeagues(currentPage, searchInput, sortRef.current.orderBy, sortRef.current.orderType, false))
  }, [currentPage])

  return (
    <div className='events-component'>
      <div className='info-div'>
        <div className='title-div'>
        <h4 className='text-ds-h3'>{window.I18n.t('gg_golf_hub.dashboard.my_events')}</h4>
         <GGButton
            label={window.I18n.t('gg_golf_hub.dashboard.create')}
            icon='square-plus-o'
            onClick={handleCreateEvent}
          />
      </div>
      <div className='title-div add-margin-top-20'>
        <div className='search-div'>
          <GGInput
            name='events-search'
            placeholder={window.I18n.t('gg_golf_hub.dashboard.search_events_placeholder')}
            icon='magnifying-glass'
            value={searchInput}
            onChange={setSearchInput}
          />
        </div>
        <StatsComponent
          numberOfEvents={numberOfLeagues}
          numberOfGolfers={numberOfGolfers}
          entryFeesSum={entryFeeSum}
        />
      </div>
      </div>
      {numberOfLeagues === 0 ? <div className='no-events'>
        {window.I18n.t('gg_golf_hub.dashboard.no_events')}
      </div> : <EventsTable
        numberOfLeagues={numberOfLeagues}
        events={leagues}
        currentPage={currentPage}
        handleChangePage={handleChangePage}
        handlePublish={handlePublish}
        handleRegistration={handleRegistration}
        onSort={handleSort}
      />}
      
    </div>

  )
}

EventsComponent.propTypes = {
  onCreate: PropTypes.func,
}

export default EventsComponent
